import { faPlaneDeparture, faPlusCircle, faStarShooting } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useParams } from 'react-router'
import { useEffect } from 'react'

import { type OnboardingPage } from '../routes'
import useMe from '../../utils/useMe'
import { OnboardingTitle } from '../components/OnboardingTitle'
import { track } from '../../utils/analytics'

import { Card, CardContent, CardActions, Button } from '@olino/design-system'

const Main = () => {
  const { id } = useParams()
  const user = useMe()
  const navigate = useNavigate()

  useEffect(() => {
    track({
      event: 'visited_tailored_finalization',
      quotation_id: id,
    })
  }, [id])

  return (
    <>
      <OnboardingTitle.H1 className="mb-5">
        Nous revenons vers vous dans les plus&nbsp;brefs délais !
      </OnboardingTitle.H1>

      <div className="mb-5">
        Au vu des éléments que vous nous avez communiqués, votre demande de devis demande un
        traitement par l'un de nos souscripteurs. Nous sommes susceptibles de vous contacter par
        téléphone et/ou par mail si nous avons besoin de plus d'informations. Vous recevrez notre
        proposition personnalisée par mail dans les meilleurs délais.
      </div>

      <Card className="sm:pt-4">
        <CardContent>
          <div className="grid max-w-4xl grid-cols-1 space-y-4 text-center text-sm sm:gap-6 md:flex-row md:space-y-0">
            <p>
              Dans l'attente, n'hésitez pas à visiter notre site internet et à nous soliciter pour
              d'autres demandes d'assurances.
            </p>
          </div>
        </CardContent>

        <CardActions>
          <div className="mt-3 flex flex-col items-center justify-center gap-6 sm:flex-row">
            {user && (
              <Button variant="outlined" onClick={() => navigate('/')}>
                Voir mes contrats
              </Button>
            )}
            <Button onClick={() => (window.location.href = 'https://pilliot-assurances.com/')}>
              <FontAwesomeIcon icon={faPlusCircle} />
              Je souhaite un devis
            </Button>
          </div>
        </CardActions>
      </Card>
    </>
  )
}

const Tips = () => {
  return undefined
}

export default {
  main: <Main />,
  tips: <Tips />,
} satisfies OnboardingPage
